import { formatMoney } from "../../../lib/formatMoney";
import AchievementCard from "../../AchievementCard/AchievementCard";
import { Grid } from "@mui/material";

const PropertyStats = ({ data }) => {
  console.log(data);
  return (
    <Grid paddingBottom={2} container spacing={2}>
      <Grid item xs={12} md={4}>
        <AchievementCard
          title={`${formatMoney({
            amount: parseFloat(data.placementGoal),
            symbol: "$ ",
            append: false,
          })} ${'USD'}`}
          description="Meta de colocación"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <AchievementCard
          title={`${formatMoney({
            amount: parseFloat(data.supply),
            symbol: "",
            append: false,
            decimals: 0,
          })} ${data.symbol}`}
          description="Número de tokens"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <AchievementCard title={data.symbol} description="Denominación" />
      </Grid>

      <Grid item xs={12} md={6}>
        <AchievementCard
          title={`${formatMoney({
            amount: parseFloat(data.approximateTotalValueUsd),
            symbol: "$ ",
            append: false,
          })} ${'USD'}`}
          description="Venta total aproximada del proyecto"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AchievementCard
          title={`${formatMoney({
            amount: parseFloat(data.approximateFinalPoolValue),
            symbol: "$ ",
            append: false,
          })} ${'USD'}`}
          description="Valor final aproximado del pool"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <AchievementCard
          title={`${formatMoney({
            amount: parseFloat(data.startPriceUsd),
            symbol: "$ ",
            append: false,
          })} ${'USD'}`}
          description="Valor inicial por token"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AchievementCard
          title={`${formatMoney({
            amount: parseFloat(data.endPriceUsd),
            symbol: "$ ",
            append: false,
          })} ${'USD'}`}
          description="Valor final del token aproximado"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <AchievementCard title={data.projection} description="Proyección" />
      </Grid>
      <Grid item xs={12} md={6}>
        <AchievementCard
          title={formatMoney({
            amount:
              (parseFloat(data.endPriceUsd) / parseFloat(data.startPriceUsd)) *
              100,
            symbol: " %",
            append: true,
            decimals: 2,
          })}
          description="Retorno aproximado"
        />
      </Grid>
    </Grid>
  );
};

export default PropertyStats;
